import { Static, Object, Optional, Number, Union, Literal, Array, Intersect } from '@sinclair/typebox';

import { PAX_TYPE } from '../sas-domain/pax';

const BasePrice = Object({
  totalTax: Number(),
  totalPrice: Number(),
  rebookFees: Optional(Number()),
  rebookPrice: Optional(Number()),
  basePrice: Number(),
});

const PassengerRevenuePrice = Intersect([
  BasePrice,
  Object({
    type: Literal('revenue'),
  }),
]);

const PassengerPointsPrice = Intersect([
  BasePrice,
  Object({
    type: Literal('points'),
    points: Number(),
    discountedPoints: Number(),
  }),
]);

const PassengerType = Union([
  Literal(PAX_TYPE.ADULT),
  Literal(PAX_TYPE.CHILD),
  Literal(PAX_TYPE.CHILD_SHORT),
  Literal(PAX_TYPE.INFANT),
  Literal(PAX_TYPE.INFANT_SHORT),
  Literal(PAX_TYPE.YOUTH),
  Literal(PAX_TYPE.UNACCOMPANIED_MINOR),
]);

const PricePerPassenger = Object({
  type: PassengerType,
  points: Number(),
  discountedPoints: Number(),
});
export type PricePerPassenger = Static<typeof PricePerPassenger>;

export type PassengerPrice = Static<typeof PassengerPrice>;
export const PassengerPrice = Union([PassengerRevenuePrice, PassengerPointsPrice]);

export type PricePerPassengerType = Static<typeof PricePerPassengerType>;
const PricePerPassengerType = Object({
  id: Number(),
  type: Optional(PassengerType),
  numberCount: Number(),
  price: Optional(PassengerPrice),
});

const RevenuePrice = Intersect([
  PassengerRevenuePrice,
  Object({
    pricePerPassengerType: Array(PricePerPassengerType),
  }),
]);

const PointsPrice = Intersect([
  PassengerPointsPrice,
  Object({
    pricePerPassengerType: Array(PricePerPassengerType),
    pricePerPassenger: Optional(Array(PricePerPassenger)),
    discountedPointsForAdult: Optional(Number()),
  }),
]);

export type Price = Static<typeof Price>;
export const Price = Union([PointsPrice, RevenuePrice]);
